// src/components/LanguageSwitch/LanguageSwitch.tsx
import React, { FC, useEffect, useState } from 'react';
import { Dropdown, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ReactComponent as LanguageIcon } from '../../assets/icons/header/language.svg';
import {
  applyAccountLanguage, changeLanguage, getLanguage, LANGUAGE_NAMES, LANGUAGES,
} from '../../i18n';
import { getUserData } from '../../views/auth/slice/selectors';
import classes from './LanguageSwitch.module.less';

// Ikona języka w górnym pasku, przed awatarem; pod nią lista języków. Wybór działa od razu, bez przeładowania
// strony. Opis: docs/plan-jezyka.md
const LanguageSwitch: FC = () => {
  const { t } = useTranslation();
  const user = useSelector(getUserData);
  const userId = user?.id;
  const [isOpen, setIsOpen] = useState(false);
  const current = getLanguage();

  // Po zalogowaniu język zapamiętany dla tego konta — na wspólnym urządzeniu każdy ma swój
  useEffect(() => {
    if (userId !== undefined) {
      applyAccountLanguage(userId);
    }
  }, [userId]);

  const menu = (
    <div className={classes.menu} role="menu">
      {LANGUAGES.map((language) => (
        <button
          key={language}
          type="button"
          role="menuitemradio"
          aria-checked={language === current}
          lang={language}
          className={classNames(classes.item, { [classes.selected]: language === current })}
          onClick={() => {
            setIsOpen(false);
            if (language !== current) {
              changeLanguage(language, userId);
            }
          }}
        >
          {LANGUAGE_NAMES[language]}
        </button>
      ))}
    </div>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      placement="bottomRight"
      visible={isOpen}
      onVisibleChange={setIsOpen}
    >
      {/* Dymek jak w reszcie aplikacji, pod ikoną (pasek jest u góry ekranu); przy otwartej liście schowany */}
      <Tooltip title={isOpen ? '' : t('common:language.label')} placement="bottom">
        <button
          type="button"
          className={classNames(classes.button, { [classes.open]: isOpen })}
          aria-label={t('common:language.label')}
          aria-haspopup="menu"
          aria-expanded={isOpen}
        >
          <LanguageIcon className={classes.icon} aria-hidden="true" />
        </button>
      </Tooltip>
    </Dropdown>
  );
};

export default LanguageSwitch;
